import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { merchantThemes } from '../Variable'

export const RefundTotalWrapper = styled.div`
	margin: ${rem(0)} auto ${rem(15)} auto;
	width: 100%;
	max-width: ${rem(419)};
`
export const RefundTotalTitle = styled.div`
	text-align: center;
	text-transform: uppercase;
	font-weight: 800;
	margin: ${rem(10, 0, 10, 0)};
	font-size: ${rem(17)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			text-transform: none;
		`}
`
export const RefundTotalBody = styled.div`
	border: ${rem(1)} solid ${({ theme }) => theme.color.graySix};
	background: ${({ theme }) => theme.color.secondary};
	padding: ${rem(8, 13)};
`
export const RefundTotalRow = styled.div`
	display: flex;
	color: ${({ theme }) => theme.color.grayThree};
	font-size: ${rem(12)};
	padding: ${rem(2, 0)};
	font-weight: 800;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
		`}
`
export const RefundTotalRowKey = styled.div`
	width: 50%;
`
export const RefundTotalRowPrice = styled.div`
	width: 50%;
	text-align: right;
`
export const RefundTotalAfterBody = styled.div`
	position: relative;
	margin: ${rem(5, 0, 0, 0)};
	padding: ${rem(5, 0, 0, 0)};
	&:before {
		position: absolute;
		content: '';
		height: ${rem(1)};
		top: 0;
		left: ${rem(-8)};
		right: ${rem(-8)};
		background-color: ${({ theme }) => theme.color.graySix};
	}
`
